<template>
  <div id="app">
    <navbar />

    <b-card bg-variant="danger" text-variant="white" class="rounded-0" v-if="this.$router.currentRoute.name == 'home'">
      <b-row>
        <b-col sm="6">
          <div class="d-lg-none">
          <h1 class="display-4">Are you or your family getting sick?</h1>
          </div>
          <div class="d-none d-lg-block">
          <h1 class="display-3">Are you or your family getting sick?</h1>
          </div>
          <h1>It could be your home&hellip;</h1>
          <p>
            According to the CDC
            <sup>
              <a href="#footnote-1">&dagger;</a>
            </sup>, exposure to mold and other substances can lead to symptoms such as stuffy nose, wheezing, and red or itchy eyes, or skin. Some people, such as those with allergies to molds or with asthma, may have more intense reactions. Severe reactions may include fever and shortness of breath.
          </p>
        </b-col>
        <b-col sm="6">
          <h3>At Commonwealth Moisture &amp; Mold Specialists, we can test for the following substances which could be harmful to you and your family <sup>*</sup>:</h3>
          <br />
          <h4 class="text-center">Mold</h4>
          <h4 class="text-center">Bacteria</h4>
          <h4 class="text-center">Pollen</h4>
          <h4 class="text-center">And More...</h4>
          <div class="text-center">
            <br />
            <b-button variant="primary" to="/testing">Learn More</b-button>&nbsp;
            <b-button variant="secondary" to="/contact">Contact Us</b-button>
          </div>
        </b-col>
      </b-row>
                <small><sup>*</sup>Testing and lab fees apply. Contact us for an appointment</small>

    </b-card>

    <br />

    <b-img src="/logo.png" fluid rounded center />
    <br />
    <router-view />
    <c-footer v-if="this.$router.currentRoute.name != 'testing'"/>
    <c-footer v-else text="Testing and lab fees apply. Contact us for an appointment." />
  </div>
</template>

<script>
import Navbar from "./components/Navbar.vue";
import CFooter from "./components/Footer.vue";
export default {
  components: {
    Navbar,
    CFooter
  },
  computed: {
    showWarning() {
      console.log('here')
      console.log(this.$router)
      if (window && window.location.pathname == '/') {

        return true;
      } else {
        return false;
      }
    }
  }
};
</script>


<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
